import { Link } from 'react-router-dom';
import type { UserDto } from '../api/types';

interface Props {
  user?: UserDto;
}

/**
 * Header avec logo SVG complet "com€asy" + avatar utilisateur cliquable.
 * Le logo reproduit fidèlement celui de la maquette d'origine.
 */
export function Header({ user }: Props) {
  // Initiales à partir du displayName ("Christophe Falesse" → "CF")
  const initials = user?.displayName
    ? user.displayName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(s => s.charAt(0).toUpperCase())
        .join('')
    : '?';

  return (
    <header
      className="sticky top-0 z-30 bg-white border-b border-border"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="max-w-3xl mx-auto flex items-center justify-between px-4 py-3">
        {/* Logo SVG complet com€asy */}
        <Link to="/" aria-label="Accueil ComEasy" className="block">
          <svg
            viewBox="0 0 120 50"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            className="h-9 w-auto"
            preserveAspectRatio="xMinYMid meet"
          >
            <title>ComEasy</title>
            <defs>
              <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@200;300&family=Cormorant+Garamond:ital,wght@1,400&display=block');
                .cea-logo-main { font-family: 'Josefin Sans', sans-serif; font-weight: 200; }
                .cea-logo-tagline { font-family: 'Cormorant Garamond', serif; font-style: italic; font-weight: 400; }
              `}</style>
            </defs>
            <text x="0" y="36" className="cea-logo-main" fontSize="34" letterSpacing="-2">
              <tspan fill="#21b3a3" fontSize="42" fontWeight="300">c</tspan>
              <tspan fill="#0d0d0d">om</tspan>
              <tspan fill="#C89010" fontSize="25" fontWeight="300">€</tspan>
              <tspan fill="#0d0d0d">as</tspan>
            </text>
            <path
              d="M 101 20 L 107 34 M 119 8 L 100 49"
              fill="none"
              stroke="#C89010"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line x1="7" y1="44" x2="13" y2="44" stroke="#21b3a3" strokeWidth="0.3" opacity="0.7" />
            <text
              x="46.5"
              y="45"
              textAnchor="middle"
              className="cea-logo-tagline"
              fontSize="6.5"
              fill="rgba(0,0,0,0.5)"
            >
              Vendez. Déclarez. Brillez.
            </text>
          </svg>
        </Link>

        {/* Avatar profil */}
        <Link
          to="/profil"
          className="w-10 h-10 rounded-full bg-surface-muted border border-border flex items-center justify-center text-ink-sub overflow-hidden shrink-0"
          aria-label="Profil"
        >
          {user?.photoUrl ? (
            <img src={user.photoUrl} alt="" className="w-full h-full object-cover" />
          ) : (
            <span className="text-sm font-demi tracking-wide">{initials}</span>
          )}
        </Link>
      </div>
    </header>
  );
}
